// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__MbNbp","label__helper":"style_label__helper__sVI8F"};